module.exports = __webpack_public_path__ + "static/media/ScrollUpButton.bb85dd7f.svg";